import type { ReactNode } from 'react';

/** Bandeau au-dessus d'un tableau : recherche à gauche, filtres et actions à droite */
export function ListToolbar({ search, children }: { search: ReactNode; children?: ReactNode }) {
  return (
    <div className="p-4 border-b border-slate-200 flex flex-col lg:flex-row gap-4 justify-between items-center bg-slate-50/50">
      {search}
      <div className="flex flex-wrap gap-2 w-full lg:w-auto">{children}</div>
    </div>
  );
}
